import React, { useState, useContext, useEffect, useRef } from "react";
import {
  TextField,
  Button,
  Paper,
  Typography,
  MenuItem,
  InputLabel,
  Grid,
  FormControl,
  Select,
  InputAdornment,
  IconButton,
  Box,
} from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { isEmpty } from "lodash";
import { Stack } from "@mui/system";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import SettingsBackupRestoreRoundedIcon from "@mui/icons-material/SettingsBackupRestoreRounded";
import PrintRoundedIcon from "@mui/icons-material/PrintRounded";
import PhotoCameraRoundedIcon from "@mui/icons-material/PhotoCameraRounded";
import ZoomInRoundedIcon from "@mui/icons-material/ZoomInRounded";
import Swal from "sweetalert2";
import ReactToPrint from "react-to-print";

import { getToken } from "../../../api/Account";
import { DataContext } from "../../../context/DataContext";

import { isAccess, simpleMessage } from "../../../helpers/Helpers";

import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import {
  getCreditByIdAsync,
  remakeCreditAsync,
  updateCreditAsync,
} from "../../../api/Credits";
import { getPeriodicidadListAsync } from "../../../api/Periodicidad";
import { getGestoresAsync } from "../../../api/Users";
import { getInteresListAsync } from "../../../api/InteresCorriente";
import { getPlazoByPeriodicidadAsync } from "../../../api/Plazo";
import PrintNotificacionCobro from "./paymentComponents/PrintNotificacionCobro";
import PrintNotificacionExtrajudicial from "./paymentComponents/PrintNotificacionExtrajudicial";
import { lightTheme } from "../../../theme";
import SmallModal from "../../../components/modals/SmallModal";
import CreditPhoto from "./photoComponent/CreditPhoto";
import PreviewModal from "../../../components/modals/PreviewModal";

const CreditDetails = ({ id, setClientName, setIsNominal, setDataCredit }) => {
  const { setIsLoading, setIsUnautorized, access } = useContext(DataContext);
  const token = getToken();

  const [selectedClient, setSelectedClient] = useState(null);

  const [periodicidadList, setPeriodicidadList] = useState([]);
  const [selectedPeriodicidad, setSelectedPeriodicidad] = useState("");

  const [plazoList, setPlazoList] = useState([]);
  const [selectedPlazo, setSelectedPlazo] = useState("");

  const [interesCorrienteList, setInteresCorrienteList] = useState([]);
  const [selectedInteresCorriente, setSelectedInteresCorriente] = useState("");

  const [gestorList, setGestorList] = useState([]);
  const [selectedGestor, setSelectedGestor] = useState("");
  const [montoPrincipal, setMontoPrincipal] = useState("");
  const [montoQuote, setMontoQuote] = useState("");
  const [destino, setDestino] = useState("");

  const [fechaPrimeraCuota, setFechaPrimeraCuota] = useState(new Date());
  const [fechaEntrega, setFechaEntrega] = useState(new Date());

  const [isEdit, setIsEdit] = useState(false);

  const [isEntregado, setIsEntregado] = useState(false);
  const [iscanceled, setIsCanceled] = useState(false);

  const [creditPhotos, setCreditPhotos] = useState([]);
  const [editPhotos, setEditPhotos] = useState(false);
  const [localReload, setLocalReload] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const compRef = useRef();
  const compRefExtrajudicial = useRef();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getCreditByIdAsync(token, id);

      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setClientName(result.data.result.client.fullName);
      setDataCredit(result.data.result);
      setSelectedClient(result.data.result.client);

      const resultPer = await getPeriodicidadListAsync(token);
      if (!resultPer.statusResponse) {
        setIsLoading(false);
        if (resultPer.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(resultPer.error, "error");
        return;
      }
      setPeriodicidadList(resultPer.data.result);

      const resultGestores = await getGestoresAsync(
        token,
        result.data.result.sucursal.id,
      );
      if (!resultGestores.statusResponse) {
        setIsLoading(false);
        if (resultGestores.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(resultGestores.error, "error");
        return;
      }
      setGestorList(resultGestores.data.result);

      const resultIC = await getInteresListAsync(token);
      if (!resultIC.statusResponse) {
        setIsLoading(false);
        if (resultIC.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(resultIC.error, "error");
        return;
      }
      setInteresCorrienteList(resultIC.data.result);

      const resultPlazo = await getPlazoByPeriodicidadAsync(
        token,
        result.data.result.periocidad.id,
      );
      if (!resultPlazo.statusResponse) {
        setIsLoading(false);
        if (resultPlazo.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(resultPlazo.error, "error");
        return;
      }

      setPlazoList(resultPlazo.data.result);
      setMontoPrincipal(result.data.result.montoPrincipal);
      setMontoQuote(result.data.result.cuotaPagar);
      setSelectedGestor(result.data.result.gestor);
      setDestino(result.data.result.destino);
      setSelectedPeriodicidad(result.data.result.periocidad.id);
      setSelectedPlazo(result.data.result.plazo.id);
      setSelectedInteresCorriente(result.data.result.tasaInteresCorriente.id);
      setFechaEntrega(new Date(result.data.result.fechaEntrega));
      setFechaPrimeraCuota(new Date(result.data.result.fechaPrimeraCuota));
      setIsEntregado(result.data.result.isEntregado);
      setIsNominal(result.data.result.isNominal);
      setIsCanceled(result.data.result.isCanceled);

      setCreditPhotos(result.data.result.creditPhotos);

      setIsLoading(false);
    })();
  }, [localReload]);

  //Devuelve un entero positivo
  const funtionSetMontoSolicitado = (value) => {
    if (/^[0-9]+$/.test(value.toString()) || value === "") {
      setMontoPrincipal(value);

      return;
    }
  };

  const handleChangePeriodicidad = async (event) => {
    const selected = periodicidadList.filter(
      (item) => item.id == event.target.value,
    );
    let dias = selected[0].cuotaDias;

    var newDate = new Date();
    newDate.setDate(newDate.getDate() + dias);

    setFechaPrimeraCuota(newDate);
    setPlazoList([]);
    setSelectedPeriodicidad(event.target.value);

    if (event.target.value !== "") {
      setIsLoading(true);
      const result = await getPlazoByPeriodicidadAsync(
        token,
        event.target.value,
      );
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }
      setPlazoList(result.data.result);
      setIsLoading(false);
    } else {
      setPlazoList([]);
    }
  };

  const saveChanges = async () => {
    if (validate()) {
      const datos = {
        id,
        montoPrincipal,
        fechaEntrega,
        fechaPrimeraCuota,
        destino,
        periocidadId: selectedPeriodicidad,
        plazoId: selectedPlazo,
        interesCorrienteId: selectedInteresCorriente,
        gestor: selectedGestor,
      };

      setIsLoading(true);
      const result = await updateCreditAsync(token, datos);
      if (!result.statusResponse) {
        setIsLoading(false);

        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }

        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      setIsEdit(false);
      simpleMessage("Crédito actualizado...!", "success");
    }
  };

  //Validando campos ingresados
  const validate = () => {
    let isValid = true;
    if (isEmpty(selectedClient)) {
      simpleMessage("Debe seleccionar un cliente", "error");
      return (isValid = false);
    }

    if (montoPrincipal === "") {
      simpleMessage("Debe ingresar un monto", "error");
      return (isValid = false);
    }

    if (fechaPrimeraCuota === "") {
      simpleMessage("Debe ingresar fecha de primera cupta", "error");
      return (isValid = false);
    }

    if (fechaPrimeraCuota === "") {
      simpleMessage("Debe ingresar una fecha de entrega", "error");
      return (isValid = false);
    }

    if (selectedGestor === "") {
      simpleMessage("Debe seleccionar un gestor", "error");
      return (isValid = false);
    }

    if (selectedPlazo === "") {
      simpleMessage("Debe seleccionar un plazo", "error");
      return (isValid = false);
    }

    if (selectedInteresCorriente === "") {
      simpleMessage("Debe seleccionar una tasa de interes", "error");
      return (isValid = false);
    }

    if (isEmpty(destino)) {
      simpleMessage("Debe seleccionar un destino de crédito", "error");
      return (isValid = false);
    }
    return isValid;
  };

  const remakeCredit = async () => {
    Swal.fire({
      title: "¿Estas Seguro de Rehacer este Crédito?",
      icon: "warning",
      showCancelButton: true,

      confirmButtonColor: "#2979ff",
      cancelButtonColor: "#f50057",

      confirmButtonText: "Rehacer!",
      cancelButtonText: "Cancelar",
      customClass: {
        popup: "border",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        (async () => {
          setIsLoading(true);
          const result = await remakeCreditAsync(token, id);
          if (!result.statusResponse) {
            setIsLoading(false);
            if (result.error === "Unauthorized") {
              setIsUnautorized(true);
              return;
            }
            simpleMessage(result.error, "error");
            return;
          }
          Swal.fire("Listo!", "", "success");
          setIsLoading(false);
          setIsEdit(false);
        })();
      }
    });
  };

  const pageStyle = `
	  @media print {
		html, body {
		  height: initial !important;
		  overflow: initial !important;
		  -webkit-print-color-adjust: exact;
		}
	  }
	  @media all {
		.pagebreak {
		  display: none;
		}
	  }
	  @media print {
		.pagebreak {
		  page-break-before: always;
		}
	  }
	  @page {   margin: 10mm; }
	`;

  const handleOpen = (imageUrl) => {
    setSelectedImage(imageUrl);
    setOpenModal(true);
  };

  return (
    <div>
      <Paper sx={{ padding: "22px 24px" }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems={{ xs: "flex-start", sm: "center" }}
          justifyContent="space-between"
          spacing={1.5}
          flexWrap="wrap"
          sx={{ marginBottom: "18px" }}
        >
          <Typography sx={{ fontSize: 15, fontWeight: 600 }}>Datos del crédito</Typography>

          <Stack direction="row" spacing={1.1} flexWrap="wrap">
            {isAccess(access, "CREDITS UPDATE") ? (
              <Button
                variant="outlined"
                color="success"
                startIcon={<EditRoundedIcon sx={{ fontSize: 17 }} />}
                onClick={() => setIsEdit(!isEdit)}
                size="small"
              >
                Editar
              </Button>
            ) : null}

            {isAccess(access, "CREDITS REGEN") ? (
              <Button
                variant="outlined"
                color="error"
                startIcon={<SettingsBackupRestoreRoundedIcon sx={{ fontSize: 17 }} />}
                onClick={() => remakeCredit()}
                size="small"
              >
                Reconstruir
              </Button>
            ) : null}

            <ReactToPrint
              trigger={() => (
                <Button variant="outlined" startIcon={<PrintRoundedIcon sx={{ fontSize: 17 }} />} size="small">
                  Notificación
                </Button>
              )}
              content={() => compRef.current}
              pageStyle={pageStyle}
            />

            <ReactToPrint
              trigger={() => (
                <Button variant="outlined" startIcon={<PrintRoundedIcon sx={{ fontSize: 17 }} />} size="small">
                  Notificación Extrajudicial
                </Button>
              )}
              content={() => compRefExtrajudicial.current}
              pageStyle={pageStyle}
            />
          </Stack>
        </Stack>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={6}>
            <Stack spacing={2}>
              <TextField
                disabled={!isEdit}
                required
                fullWidth
                onChange={(e) => funtionSetMontoSolicitado(e.target.value)}
                value={montoPrincipal}
                label={"Monto Solicitado"}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">C$</InputAdornment>
                  ),
                }}
              />

              <TextField
                disabled
                required
                fullWidth
                value={montoQuote}
                label={"Monto Quota"}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">C$</InputAdornment>
                  ),
                }}
              />

              <FormControl disabled={!isEdit} fullWidth style={{ textAlign: "left" }}>
                <InputLabel id="demo-simple-select-standard-label">Gestor</InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  onChange={(e) => setSelectedGestor(e.target.value)}
                  value={selectedGestor}
                  label="Gestor"
                  style={{ textAlign: "left" }}
                >
                  <MenuItem value="">
                    <em>Seleccione un Gestor</em>
                  </MenuItem>
                  {gestorList.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.fullName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {isEntregado ? (
                <DesktopDatePicker
                  disabled={!isEdit}
                  closeOnSelect
                  label="Fecha de Entrega"
                  inputFormat="DD/MM/YYYY"
                  value={fechaEntrega}
                  onChange={(newValue) => setFechaEntrega(newValue)}
                  renderInput={(params) => <TextField {...params} />}
                />
              ) : (
                <TextField disabled fullWidth value="NO ENTREGADO" label={"Estado"} />
              )}

              <DesktopDatePicker
                disabled={!isEdit}
                closeOnSelect
                label="Fecha Primera Cuota"
                inputFormat="DD/MM/YYYY"
                value={fechaPrimeraCuota}
                onChange={(newValue) => setFechaPrimeraCuota(newValue)}
                renderInput={(params) => <TextField {...params} />}
              />
            </Stack>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Stack spacing={2}>
              <TextField
                disabled={!isEdit}
                required
                fullWidth
                onChange={(e) => setDestino(e.target.value.toUpperCase())}
                value={destino}
                label={"Destino"}
              />

              <FormControl disabled={!isEdit} fullWidth style={{ textAlign: "left" }}>
                <InputLabel id="demo-simple-select-standard-label">Periodicidad</InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  onChange={handleChangePeriodicidad}
                  value={selectedPeriodicidad}
                  label="Periodicidad"
                  style={{ textAlign: "left" }}
                >
                  <MenuItem value="">
                    <em>Seleccione un Periodo</em>
                  </MenuItem>
                  {periodicidadList.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.description}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl disabled={!isEdit} fullWidth style={{ textAlign: "left" }}>
                <InputLabel id="demo-simple-select-standard-label">Plazo</InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  onChange={(e) => setSelectedPlazo(e.target.value)}
                  value={selectedPlazo}
                  label="Plazo"
                  style={{ textAlign: "left" }}
                >
                  <MenuItem value="">
                    <em>Seleccione un Plazo</em>
                  </MenuItem>
                  {plazoList.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.description}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl disabled={!isEdit} fullWidth style={{ textAlign: "left" }}>
                <InputLabel id="demo-simple-select-standard-label">Tasa de interes</InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  onChange={(e) => setSelectedInteresCorriente(e.target.value)}
                  value={selectedInteresCorriente}
                  label="Tasa de interes"
                  style={{ textAlign: "left" }}
                >
                  <MenuItem value="">
                    <em>Seleccione una Tasa de Interes</em>
                  </MenuItem>
                  {interesCorrienteList.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {`${item.intCorriente.toFixed(2)} %`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <TextField disabled fullWidth value={iscanceled ? "CANCELADO" : "NO CANCELADO"} label={"Estado Credito"} />
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ marginTop: "6px" }}>
              <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ xs: "flex-start", sm: "center" }} spacing={1}>
                <Typography sx={{ fontSize: 13.5, fontWeight: 600 }}>Fotos del crédito</Typography>

                <Button
                  onClick={() => setEditPhotos(true)}
                  color="warning"
                  variant="outlined"
                  size="small"
                  startIcon={<PhotoCameraRoundedIcon sx={{ fontSize: 17 }} />}
                  disabled={!isEdit}
                >
                  Cambiar fotos
                </Button>
              </Stack>

              <Grid container spacing={1.5} sx={{ marginTop: "4px" }}>
                {creditPhotos.map((preview, index) => (
                  <Grid item xs={6} sm={4} key={index}>
                    <Box
                      sx={{
                        position: "relative",
                        borderRadius: "11px",
                        border: "1px solid",
                        borderColor: "divider",
                        height: 160,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                        backgroundColor: "background.default",
                      }}
                    >
                      <img
                        src={preview.imageFullPath}
                        alt={`Vista previa ${index + 1}`}
                        style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                      />

                      <IconButton
                        sx={{
                          position: "absolute",
                          top: 8,
                          right: 8,
                          backgroundColor: "rgba(0,0,0,.35)",
                          color: "#fff",
                          "&:hover": { backgroundColor: "rgba(0,0,0,.55)" },
                          width: 32,
                          height: 32,
                        }}
                        onClick={() => handleOpen(preview.imageFullPath)}
                      >
                        <ZoomInRoundedIcon sx={{ fontSize: 18 }} />
                      </IconButton>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Grid>
        </Grid>

        {isAccess(access, "CREDITS UPDATE") ? (
          <Button
            variant="contained"
            color="primary"
            fullWidth
            startIcon={<SaveRoundedIcon />}
            onClick={() => saveChanges()}
            sx={{ marginTop: "22px", padding: "12px" }}
            disabled={!isEdit}
          >
            Actualizar crédito
          </Button>
        ) : null}
      </Paper>

      <SmallModal titulo={"Editar Fotos"} isVisible={editPhotos} setVisible={setEditPhotos}>
        <CreditPhoto
          id={id}
          localReload={localReload}
          setLocalReload={setLocalReload}
          clientPhotos={creditPhotos}
          setEditPhotos={setEditPhotos}
        />
      </SmallModal>

      <PreviewModal
        openModal={openModal}
        selectedImage={selectedImage}
        setOpenModal={setOpenModal}
        setSelectedImage={setSelectedImage}
      />

      <div style={{ display: "none" }}>
        <ThemeProvider theme={lightTheme}>
          <PrintNotificacionCobro id={id} ref={compRef} />
          <PrintNotificacionExtrajudicial id={id} ref={compRefExtrajudicial} />
        </ThemeProvider>
      </div>
    </div>
  );
};

export default CreditDetails;
